import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { PageTemplateTable } from '../../../directives/page-template-table/page-template-table';
import { DigitalCouponService } from '../../../services/api-appointment/digital-coupon/digital-coupon.service';
import { SpinnerService } from '../../../services/spinner/spinner.service';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import {  NgbDate ,  NgbCalendar ,  NgbDateParserFormatter ,  NgbDateStruct ,  NgbModal  } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DigitalcouponRequestExportCsv, DigitalcouponRequestSearch } from '../../../models/api-appointment/digital-coupon/digital-coupon.request.model';
import { TRUE } from '../../../utils/config/const';
import { User } from '../../../models/user';

@Component({
  selector: 'app-digitalcoupon',
  templateUrl: './digitalcoupon.component.html',
  styleUrls: ['./digitalcoupon.component.css']
})
export class DigitalcouponComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {

  currentUser: User;
  searchFilterForm: FormGroup;
  hoveredDate: NgbDate | null = null;
  fromDate: any
  toDate: any
  convertedFromDate: any;
  convertedToDate: any;
  storeAddress = '';
  storeCity = '';
  request: any = {};
  exportDivOpen: boolean = false;
  public isEmpty: boolean = false;
  public isSearching: boolean = false;
  maxDate: NgbDateStruct;
  start:string = null;
  end:string = null;
  isSearchReserved:boolean = true;

  constructor(
    private authenticationService: AuthenticationService,
    private digitalCouponService: DigitalCouponService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    private toastr: ToastrService,
    private router: Router,
    public modalService: NgbModal
  ) { 
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: '',
      searchFilterField_reservedOldValue: '',
      searchFilterField_reserved: '',
      searchFilterField_start:'',
      searchFilterField_end:''
    });
    this.getDefaultDate();
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

/**
* Inizializza la tabella
*/
initTable() {
  const that = this;
  this.initCommon_dtOptions();
  this.dtOptions['columnDefs'] = [
    {orderable: false,targets: 0,width:'15%'},
    {orderable: false,targets: 1,width:'15%'},
    {orderable: false,targets: 2,width:'20%'},
    {orderable: false,targets: 3,width:'20%'},
    {orderable: false,targets: 4,width:'5%'}
  ];
  this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
    this.isSearching = true;
    
    if (dataTablesParameters.start > 0) {
      dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
    }
    that.numeroPagina = dataTablesParameters.start;
    that.dimPagina = dataTablesParameters.length;
    let digitalcouponRequestSearch = that.getFilter();
    that.digitalCouponService.search(digitalcouponRequestSearch).subscribe(
      (response) => {
        if(response != null && typeof response != typeof undefined){
          if (response.data.length == 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          that.setListEntityList(response);
          callback({
            recordsTotal: response.total,
            recordsFiltered: response.total,
            data: []
          });
        }else{
          this.isEmpty = false;
          callback({
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
          });
        }
        that.spinner.hide();
        that.isSearching = false;
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        that.spinner.hide();
        that.isSearching = false;
      }
    );
  }
}

  ngOnInit() {
    this.initTable();
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  /**
  * Click sulla lente per la ricerca
  */
   clickSearch() {
    this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
    this.resetFilter();
    this.ajaxReload();
  }


  convertDateToString(value:NgbDate){console.log(value);
    let res = '';
    if(value!=null){
      res = value.year+"-";
      if (value.month < 10) {
        res = res + '0';
      }
      res = res+value.month + "-";
      if (value.day < 10) {
        res = res + '0';
      }
      res = res + value.day;
    }
    return res;
  }

  filterReserved(value) {
    console.log(value);
    this.searchFilterForm.controls.searchFilterField_reservedOldValue.setValue(this.searchFilterForm.controls.searchFilterField_reserved.value);
    this.resetFilter();
    this.ajaxReload();
  }

  toggleSearchReserved(){
    this.isSearchReserved = !this.isSearchReserved;
  }


  toggleCheckBoxes(elementToToggle) {
    let value = this.searchFilterForm.controls[elementToToggle].value
    this.searchFilterForm.controls[elementToToggle].setValue(!value);
    let listOfCheckboxes = document.getElementsByName('checkboxFilter') as any;
    listOfCheckboxes.forEach((item, i,) => {
      if (item.value !== elementToToggle && item.checked == TRUE) {
        item.checked = false
        this.searchFilterForm.controls[item.value].setValue(false);
      }
      if (i === listOfCheckboxes.length - 1) {
        this.changeFilter();
      }
    })
  }
  /**
   * Chiamata quando cambia un valore dei filtri
   */
  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.searchFilterForm.controls.searchFilterField_reserved.setValue(this.searchFilterForm.controls.searchFilterField_reservedOldValue.value);
    this.resetFilter();
    this.ajaxReload();
  }


  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let requestSearch = new DigitalcouponRequestSearch();
    // Search Bar
    requestSearch.q = this.searchFilterForm.controls['searchFilterField'].value;
    // Page Number
    requestSearch.pageNumber = this.numeroPagina;
    // Page Size
    requestSearch.pageSize = this.dimPagina;


    if(this.isSearchReserved == TRUE){
      // Date Filter
      if(this.searchFilterForm.controls['searchFilterField_reserved'].value != null && this.searchFilterForm.controls['searchFilterField_reserved'].value!=''){
        requestSearch.reservationDate = this.convertDateToString(this.searchFilterForm.controls['searchFilterField_reserved'].value);
      }
    }else{
      if(
        this.searchFilterForm.controls['searchFilterField_start'].value != null && 
        this.searchFilterForm.controls['searchFilterField_end'].value != null
        ){
          requestSearch.start = this.searchFilterForm.controls['searchFilterField_start'].value
          requestSearch.end = this.searchFilterForm.controls['searchFilterField_end'].value
        }
    }

    return requestSearch;
  }

  clickButtonClearFilter() {
    // Search
    this.searchFilterForm.controls.searchFilterField.setValue('');
    // Date
    this.searchFilterForm.controls.searchFilterField_reserved.setValue('');
    this.searchFilterForm.controls.searchFilterField_reservedOldValue.setValue('');
    //Range Date
    this.start = '';
    this.end = '';
    this.searchFilterForm.controls.searchFilterField_start.setValue('');
    this.searchFilterForm.controls.searchFilterField_end.setValue('');


    this.clickSearch();
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  getValue() {
    this.convertDate();
    let request = new DigitalcouponRequestExportCsv();
    request.appointmentDateFrom = this.convertedFromDate;
    request.appointmentDateTo = this.convertedToDate;
    if (this.storeAddress != '') {
      request.storeAddress = this.storeAddress;
    }
    if(this.storeCity  != ''){
      request.storeCity = this.storeCity;
    }
    return request;
  }

  save() {
    this.request = this.getValue();
    this.digitalCouponService.exportCSV(this.request).subscribe(
      (response) => {
        if (response) {
          //Salvato
          this.toastr.success('Export creato con successo', 'Crea Export', {
            timeOut: 5000
          });
          this.openExportDiv();
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante l\'Export', 'Crea Export', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }


  filterChangeRange(obj){
    this.searchFilterForm.controls.searchFilterField_start.setValue('');
    this.searchFilterForm.controls.searchFilterField_end.setValue('');
    console.log(obj);
    if(obj != null){
      if (obj.fromDate.month < 10) {
        obj.fromDate.month = '0' + obj.fromDate.month;
      }
      if (obj.fromDate.day < 10) {
        obj.fromDate.day = '0' + obj.fromDate.day;
      }
      if (obj.toDate.month < 10) {
        obj.toDate.month = '0' + obj.toDate.month;
      }
      if (obj.toDate.day < 10) {
        obj.toDate.day = '0' + obj.toDate.day;
      }
      this.start = obj.fromDate.year + '-' + obj.fromDate.month + '-' + obj.fromDate.day;
      this.end = obj.toDate.year + '-' + obj.toDate.month + '-' + obj.toDate.day;
      let fromDate = obj.fromDate.year + '-' + obj.fromDate.month + '-' + obj.fromDate.day + " 00:00";
      let toDate = obj.toDate.year + '-' + obj.toDate.month + '-' + obj.toDate.day + " 23:59";
      this.searchFilterForm.controls.searchFilterField_start.setValue(fromDate);
      this.searchFilterForm.controls.searchFilterField_end.setValue(toDate);

      this.resetFilter();
      this.ajaxReload();
    }
  }



  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  convertDate() {
    if (this.fromDate.month < 10 && this.fromDate.month.toString().length == 1) {
      this.fromDate.month = '0' + this.fromDate.month;
    }
    if (this.fromDate.day < 10 && this.fromDate.day.toString().length == 1) {
      this.fromDate.day = '0' + this.fromDate.day;
    }
    if (this.toDate.month < 10 && this.toDate.month.toString().length == 1) {
      this.toDate.month = '0' + this.toDate.month;
    }
    if (this.toDate.day < 10 && this.toDate.day.toString().length == 1) {
      this.toDate.day = '0' + this.toDate.day;
    }
    this.convertedFromDate = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    this.convertedToDate = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
  }

  openExportDiv() {
    this.exportDivOpen = !this.exportDivOpen;
  }

  clickButtonUpdate(id) {
    const url = 'digitalcoupon/' + id;
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
  }

  getDateRange(range) {
    if (range == 'month') {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 30);
      this.toDate = this.calendar.getToday();
    } else {
      this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 7);
      this.toDate = this.calendar.getToday();
    }
  }

  getDefaultDate() {
    this.fromDate = this.calendar.getPrev(this.calendar.getToday(), 'd', 7);
    this.toDate = this.calendar.getToday();
    this.maxDate = { year: this.toDate.year, month: this.toDate.month, day: this.toDate.day };
  }

  resetForm() {
    this.getDateRange('month');
    this.storeCity = '';
    this.storeAddress = '';
  }

 


  customClass(date:NgbDateStruct){
      let isSelected=false;
      if(this.searchFilterForm.controls.searchFilterField_reserved.value != null && typeof this.searchFilterForm.controls.searchFilterField_reserved.value != typeof undefined){
        isSelected = [this.searchFilterForm.controls.searchFilterField_reserved.value]
        .find(d=>d.year==date.year && d.month==date.month && d.day==date.day)
      }
      return isSelected?'custom-day selected':'custom-day';
  }

  get userRole() {
    let res = "";
    for (let i = 0; i < this.currentUser.userBackend.authorities.length && res == ""; i++) {
      if (this.currentUser.userBackend.authorities[i].authority.startsWith("ROLE_")) {
        res = this.currentUser.userBackend.authorities[i].authority;
      }
    }
    console.log(res);
    return res;
  }

}
